import { connect } from "react-redux";
import { DataTableRandomiser as Component } from "./DataTableRandomiser";

function mapStateToProps(state) {
  return {
    actualResults: state.electronicScale,
  };
}

function mapDispatchToProps() {
  return {};
}

export const DataTableRandomiser = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
